import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Reasons.css'

const cardContent = [
  {
    title: "Automated Accounting Processes",
    description: `Automates journal entries, accounts receivable, and payable, ensuring accuracy, reducing errors, and streamlining financial operations.`,
  },
  {
    title: "Financial Control & Budgeting",
    description: `Enhances cash flow management, asset tracking, and budgeting, helping businesses prevent overspending and improve financial forecasting.`,
  },
  {
    title: "Seamless Banking & Reconciliation",
    description: `Simplifies reconciliations, bank statements, and payment methods, ensuring transactions align with accounting records and reducing discrepancies.`,
  },
  {
    title: "Comprehensive Sales & Customer Management",
    description: `Manages the full sales lifecycle, from lead nurturing to after-sales support, helping businesses build lasting customer relationships.`,
  },
  {
    title: "Efficient Procurement & Inventory Control",
    description: `Optimizes the order-to-pay cycle, purchase tracking, and audits, ensuring cost efficiency, transparency, and reduced procurement risks.`,
  },
  {
    title: "Integrated Customer Data Management",
    description: `Centralizes customer records and syncs with CRM tools, enabling personalized engagement and improved customer service efficiency.`,
  },
  {
    title: "Real-time Business Intelligence & Reporting",
    description: `Provides real-time insights with customizable reports, enabling better strategic planning and performance tracking through key metrics.`,
  },
  {
    title: "Interactive & Visual Data Analysis",
    description: `Integrates with analytical tools for intuitive reports, dashboards, and data comparisons, supporting better decision-making.`,
  },
  {
    title: "Mobile Sales & Accessibility",
    description: `Empowers sales teams with real-time data access on any device, enabling efficient deal closures and instant customer service.`,
  },
  {
    title: "Automated Service & Warranty Management",
    description: `Tracks service contracts, logs service calls, and automates ticket handling to reduce response time and enhance customer satisfaction.`,
  },
  {
    title: "Real-time Warehouse & Inventory Sync",
    description: `Ensures accurate stock levels, purchase planning, and automatic invoice creation, improving supplier management and avoiding shortages.`,
  },
  {
    title: "Intuitive UI & Workflow Alerts",
    description: `Enhances productivity with search assistance, drag-and-drop features, and automated notifications for critical business events.`,
  },
];



const Reasons = () => {
    return (
      <Container className='mt-4'>
        <div className='mb-4'>
          <div className='charhead'>Reasons why your business needs SAP Business One (SAP B1)</div>
        </div>
        <Row>
          {cardContent.map((item, index) => (
            <Col md={6} lg={4} key={index} className="mb-2">
              <div className="reason-card">
                <div className="content">
                  <p className="logo">{(index + 1).toString().padStart(2, '0')}</p>
                  <div className="h6">{item.title}</div>
                  <div className="hover_content">
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    );
  };

  export default Reasons;